import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "../components/Logo";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Titolare del trattamento", "Red Stone — Bar • Ristopub • Pizzeria, Via Giacomo Matteotti 398, 03023 Ceccano (FR). [Dati del titolare da completare con ragione sociale e P.IVA ufficiali.]"],
      ["Dati raccolti", "Tramite il modulo di prenotazione raccogliamo nome, cognome, telefono, email (facoltativa), data, orario e numero di ospiti, al solo scopo di gestire la tua richiesta di prenotazione."],
      ["Finalità e base giuridica", "I dati sono trattati esclusivamente per rispondere alla richiesta di prenotazione inviata volontariamente dall'utente (art. 6 par. 1 lett. b GDPR)."],
      ["Conservazione", "Le richieste di prenotazione sono conservate per il tempo necessario alla gestione della prenotazione e cancellate su richiesta."],
      ["Diritti dell'interessato", "Puoi richiedere in qualsiasi momento accesso, rettifica o cancellazione dei tuoi dati contattandoci ai recapiti indicati nella sezione Contatti."],
      ["Cookie", "Questo sito non utilizza cookie di profilazione di terze parti. Per maggiori dettagli consulta la Cookie Policy."],
    ],
  },
  cookie: {
    title: "Cookie Policy",
    sections: [
      ["Cosa sono i cookie", "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva."],
      ["Cookie utilizzati da questo sito", "Questo sito utilizza esclusivamente cookie tecnici necessari al funzionamento (ad esempio la sessione dell'area riservata del gestore). Non vengono utilizzati cookie di profilazione né cookie di terze parti a fini pubblicitari."],
      ["Servizi di terze parti", "La mappa di Google Maps incorporata nella sezione 'Dove Siamo' può installare cookie propri secondo le informative di Google."],
      ["Gestione delle preferenze", "Puoi gestire o eliminare i cookie direttamente dalle impostazioni del tuo browser."],
    ],
  },
};

export default function LegalPage({ kind }) {
  const page = CONTENT[kind];
  useEffect(() => {
    document.title = `${page.title} | Red Stone Ceccano`;
    window.scrollTo(0, 0);
    return () => { document.title = "Red Stone Ceccano | Bar • Ristopub • Pizzeria a Ceccano (FR)"; };
  }, [page.title]);

  return (
    <div className="min-h-screen bg-obsidian text-cream" data-testid={`legal-${kind}-page`}>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-cream-muted hover:text-gold-glow transition-colors">
          <ArrowLeft className="w-4 h-4" /> Torna al sito
        </Link>
        <div className="mt-10 flex items-center gap-5">
          <LogoMark className="h-14" />
          <h1 className="font-serif text-4xl">{page.title}</h1>
        </div>
        <div className="mt-10 space-y-8">
          {page.sections.map(([h, p]) => (
            <section key={h}>
              <h2 className="font-serif text-xl text-gold-glow">{h}</h2>
              <p className="mt-2.5 text-sm text-cream-muted leading-relaxed">{p}</p>
            </section>
          ))}
        </div>
        <p className="mt-14 text-[11px] text-cream-subtle/70">Ultimo aggiornamento: luglio 2026 — documento da integrare con i dati legali ufficiali del locale.</p>
      </div>
    </div>
  );
}
